import React from "react";
import {SdfBox, SdfShimmer} from "@synerg/react-components";

export function BoxShimmer({rows = 17}) {
    return (
        <SdfBox className="my-8 h-md">
            <SdfShimmer rows={rows}/>
        </SdfBox>
    )
}